<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-12">
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-button type="info" :title="$t('Yenilə')" size="small" @click="getData"><i class="fa-solid fa-rotate"></i>
            {{$t('Yenilə')}}</el-button>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12">
        <el-input :placeholder="$t('Axtar')" size="small" v-model="search"> </el-input>
      </div>
    </div>

    <br />
<el-form v-loading="loading">
  <div class="row">
    <div class="col-12 col-md-6"  v-for="(item, index) in filteredData" :key="item.id + '-' + index">
      <div 
        class="accident-item-container"
        @click="clickCard(item.id)"
      >
        <accident-card 
          v-if="item.policyType === null || item.policyType === 1" 
          :item="item" 
          @send="send" 
          class="accident-card-clickable"
        />
        <other-accident-card 
          v-else 
          :item="item" 
          @send="send"
          class="accident-card-clickable"
        />
      </div>
    </div>
  </div>
</el-form>
  </div>
</template>

<script>
import {
  GetAccidentsByStage,
  SendToClientService,
} from "src/services/accident";
import AccidentCard from "../components/AccidentCard.vue";
import OtherAccidentCard from "../components/OtherAccidentCard.vue";
export default {
  components: {
    AccidentCard,
    OtherAccidentCard,
  },
  data() {
    return {
      loading: false,
      data: [],
      search: "",
      uid: this.$store.state.user.id,
    };
  },
  methods: {
    clickCard(id) {
      this.$router.push({
        path: "accident/" + id,
      });
    },
    send(id) {
      this.$confirm(this.$t('Müraciət_Müştəri_xidmətinə_göndərilsin'), this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
        type: "info",
      })
        .then(() => {
          this.loading = true;
          SendToClientService(id, this.uid).then((response) => {
            this.loading = false;
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0],
                });
              } else {
                this.$message({
                  type: "success",
                  message: this.$t('Müştəri_xidmətinə_göndərildi'),
                });
                this.getData();
              }
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          });
        })
        .catch(() => {
          this.loading = false;
          this.$message({
            type: "info",
            message: "Xitam verildi",
          });
        });
    },
    getData() {
      this.loading = true;
      GetAccidentsByStage(2, true, this.uid)
        .then((response) => {
          this.loading = false;
          console.log(response)
          if (response.data.isSuccess) {
            this.data = response.data.data.filter(item => ![11, 13].includes(item.statusTypeId));
          }
        })
        .catch((error) => {
          this.loading = false;
        });
    },
  },
  computed: {
    
    filteredData() {
      return this.data.filter((item) => {
        const searchLower = this.search.toLowerCase();
        return (
          !this.search ||
          (item.regNumber && item.regNumber.toString().toLowerCase().includes(searchLower)) ||
          (item.dispAccidentNumber && item.dispAccidentNumber.toString().toLowerCase().includes(searchLower))
        );
      });
    }
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.accident-item-container {
  padding: 5px;
}

</style>